export default {
  title: 'Non-compliances',
  title_serviceOrder: 'Activity non-compliances',
  title_formReply: 'Form non-compliances',
  question: 'Question',
  place: 'Place',
  status: 'Status',
  opened: 'Opened',
  concluded: 'Concluded',
  instancesCount: 'Instances count',
  instances: '{{count}} instances',
  lastTime: 'Last time {{time}}',
  actionPlans: 'Action plans',
  automations: 'Automations',
  integrations: 'Integrations',
  moreOptions: 'More options'
}
